import React, { useState, useEffect } from 'react';

// Hourly positions for orb movement
const hourlyPositions = {
  0: { top: 88, left: -27 },   // 12 AM
  1: { top: 74, left: -25 },   // 1 AM
  2: { top: 73, left: -19 },   // 2 AM
  3: { top: 70, left: -15 },   // 3 AM
  4: { top: 70, left: -10 },   // 4 AM
  5: { top: 69, left: -22 },   // 5 AM
  6: { top: 52, left: -9 },    // 6 AM
  7: { top: 52, left: 5 },     // 7 AM
  8: { top: 36, left: 14 },    // 8 AM
  9: { top: 27, left: 24 },    // 9 AM
  10: { top: 18, left: 28 },   // 10 AM
  11: { top: -7, left: 34 },   // 11 AM
  12: { top: -9, left: 50 },   // 12 PM
  13: { top: -1, left: 57 },   // 1 PM
  14: { top: 12, left: 61 },   // 2 PM
  15: { top: 18, left: 70 },   // 3 PM
  16: { top: 25, left: 77 },   // 4 PM
  17: { top: 36, left: 80 },   // 5 PM
  18: { top: 47, left: 85 },   // 6 PM
  19: { top: 56, left: 87 },   // 7 PM
  20: { top: 70, left: 91 },   // 8 PM
  21: { top: 80, left: 98 },   // 9 PM
  22: { top: 93, left: 99 },   // 10 PM
  23: { top: 100, left: 100 }  // 11 PM
};

// Linear interpolation function
const lerp = (start, end, factor) => {
  return start + (end - start) * factor;
};

// Get interpolated position based on current time
const getInterpolatedPosition = (hour, minute) => {
  const currentPos = hourlyPositions[hour];
  const nextHour = (hour + 1) % 24;
  const nextPos = hourlyPositions[nextHour];
  
  if (!currentPos || !nextPos) return currentPos || { top: 50, left: 50 };
  
  // Calculate interpolation factor (0 to 1 based on minutes)
  const factor = minute / 60;
  
  return {
    top: lerp(currentPos.top, nextPos.top, factor),
    left: lerp(currentPos.left, nextPos.left, factor)
  };
};

export const useOrbPosition = () => {
  const [position, setPosition] = useState({ top: 50, left: 50 });
  
  useEffect(() => {
    const updatePosition = () => {
      const now = new Date();
      const hour = now.getHours();
      const minute = now.getMinutes();
      
      const interpolatedPos = getInterpolatedPosition(hour, minute);
      setPosition(interpolatedPos);
      
      console.log(`Time: ${hour}:${minute.toString().padStart(2, '0')}, Orb position: top ${interpolatedPos.top.toFixed(1)}%, left ${interpolatedPos.left.toFixed(1)}%`);
    };
    
    // Update immediately
    updatePosition();
    
    // Update every minute for smooth transitions
    const interval = setInterval(updatePosition, 60000);
    
    return () => clearInterval(interval);
  }, []);
  
  return position;
};